import { sagas as maintenanceRequestSagas } from './modules/maintenanceRequests'

export default [...maintenanceRequestSagas]
